import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import { IoLockClosed } from "react-icons/io5";
import { Typography } from "@mui/material";
import VuiBox from "components/ui/VuiBox";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "components/navigation/Sidenav/styles/sidenavCollapse";
import { useUIController } from "context";

function SidenavCollapse({ color, icon, name, children, active, noCollapse, open, locked, ...rest }) {
  const [controller] = useUIController();
  const { miniSidenav, transparentSidenav } = controller;

  return (
    <>
      <ListItem component="li" {...rest} sx={{ width: "100%", p: 0, m: 0 }}>
        <VuiBox sx={(theme) => collapseItem(theme, { active, transparentSidenav, locked, miniSidenav })}>
          <ListItemIcon
            sx={(theme) => collapseIconBox(theme, { active, transparentSidenav, color })}
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={
              <VuiBox display="flex" alignItems="center" sx={{ color: "#ffffff" }}>
                <Typography color="#ffffff" style={{ color: "#ffffff", fontWeight: "inherit", fontSize: "inherit" }}>
                  {name}
                </Typography>
                {locked && (
                  <IoLockClosed
                    size="10px"
                    style={{
                      marginLeft: "5px",
                      opacity: 0.7,
                      color: "#4299e1",
                    }}
                  />
                )}
              </VuiBox>
            }
            sx={(theme) => ({
              ...collapseText(theme, { miniSidenav, transparentSidenav, active }),
              "& .MuiListItemText-primary": {
                color: "#ffffff",
              }
            })}
          />
          {children && !noCollapse && !miniSidenav && (
            <Icon
              sx={{
                color: active ? "white" : "text.main",
                marginLeft: "auto",
                transition: "transform 200ms ease-in-out",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
              }}
            >
              expand_more
            </Icon>
          )}
        </VuiBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

SidenavCollapse.defaultProps = {
  color: "info",
  active: false,
  noCollapse: false,
  children: false,
  open: false,
  locked: false,
};

SidenavCollapse.propTypes = {
  color: PropTypes.oneOf(["info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  open: PropTypes.bool,
  locked: PropTypes.bool,
};

export default SidenavCollapse;
